"use strict";
// _validation.js
// 入力フォームページ（#entry）専用バリデーション

if (document.querySelector("#entry")) {
  const form = document.querySelector("#contact-form");

  if (form) {
    // ===================================
    // 要素の取得
    // ===================================
    var inName = document.querySelector("#inName");
    var errorName = document.querySelector("#emName");
    var inEmail = document.querySelector("#inEmail");
    var errorEmail = document.querySelector("#emEmail");
    var inEmailConfirm = document.querySelector("#inEmailConfirm");
    var errorEmailConfirm = document.querySelector("#emEmailConfirm");
    var inSelect = document.querySelector("#inSelect");
    var errorSelect = document.querySelector("#emSelect");
    var submitButton = form.querySelector("#button");

    if (submitButton) {
      // ===================================
      // バリデーション判定
      // ===================================
      function isNameValid() {
        return inName.value.trim() !== "";
      }
      function isEmailValid() {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inEmail.value.trim());
      }
      function isEmailConfirmValid() {
        return (
          inEmailConfirm.value.trim() !== "" && inEmailConfirm.value.trim() === inEmail.value.trim()
        );
      }
      function isSelectValid() {
        return inSelect.value.trim() !== "";
      }

      function isFormValid() {
        return isNameValid() && isEmailValid() && isEmailConfirmValid() && isSelectValid();
      }

      // ===================================
      // 送信ボタン状態更新
      // ===================================
      function updateSubmitButton() {
        submitButton.disabled = !isFormValid();
      }

      // 初期状態：無効
      submitButton.disabled = true;

      // ===================================
      // エラー表示ヘルパー
      // ===================================
      function setError(errorEl, message) {
        if (errorEl) errorEl.textContent = message;
      }
      function clearError(errorEl) {
        if (errorEl) errorEl.textContent = "";
      }

      function scrollToElement(element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      // ===================================
      // ボタンクリック時バリデーション
      // ===================================
      submitButton.addEventListener("click", function (event) {
        var hasError = false;

        if (!isNameValid()) {
          inName.classList.add("invalid");
          setError(errorName, "必須項目です。");
          if (!hasError) {
            scrollToElement(inName);
            hasError = true;
          }
          event.preventDefault();
        } else {
          inName.classList.remove("invalid");
          clearError(errorName);
        }

        if (!isEmailValid()) {
          inEmail.classList.add("invalid");
          setError(errorEmail, "メールアドレスの形式でご入力ください。");
          if (!hasError) {
            scrollToElement(inEmail);
            hasError = true;
          }
          event.preventDefault();
        } else {
          inEmail.classList.remove("invalid");
          clearError(errorEmail);
        }

        if (!isEmailConfirmValid()) {
          inEmailConfirm.classList.add("invalid");
          setError(errorEmailConfirm, "メールアドレスが一致しません。");
          if (!hasError) {
            scrollToElement(inEmailConfirm);
            hasError = true;
          }
          event.preventDefault();
        } else {
          inEmailConfirm.classList.remove("invalid");
          clearError(errorEmailConfirm);
        }

        if (!isSelectValid()) {
          inSelect.classList.add("invalid");
          setError(errorSelect, "選択してください。");
          if (!hasError) {
            scrollToElement(inSelect);
            hasError = true;
          }
          event.preventDefault();
        } else {
          inSelect.classList.remove("invalid");
          clearError(errorSelect);
        }
      });

      // ===================================
      // リアルタイムバリデーション
      // ===================================
      // 名前
      inName.addEventListener("blur", function () {
        if (!isNameValid()) {
          inName.classList.add("invalid");
          setError(errorName, "必須項目です。");
        } else {
          inName.classList.remove("invalid");
          clearError(errorName);
        }
        updateSubmitButton();
      });
      inName.addEventListener("focus", function () {
        if (inName.classList.contains("invalid")) clearError(errorName);
      });
      inName.addEventListener("input", updateSubmitButton);

      // メールアドレス
      inEmail.addEventListener("blur", function () {
        if (!isEmailValid()) {
          inEmail.classList.add("invalid");
          setError(errorEmail, "メールアドレスの形式でご入力ください。");
        } else {
          inEmail.classList.remove("invalid");
          clearError(errorEmail);
        }
        if (inEmailConfirm.value.trim() !== "") {
          if (!isEmailConfirmValid()) {
            inEmailConfirm.classList.add("invalid");
            setError(errorEmailConfirm, "メールアドレスが一致しません。");
          } else {
            inEmailConfirm.classList.remove("invalid");
            clearError(errorEmailConfirm);
          }
        }
        updateSubmitButton();
      });
      inEmail.addEventListener("focus", function () {
        if (inEmail.classList.contains("invalid")) clearError(errorEmail);
      });
      inEmail.addEventListener("input", updateSubmitButton);

      // メールアドレス確認
      inEmailConfirm.addEventListener("blur", function () {
        if (!isEmailConfirmValid()) {
          inEmailConfirm.classList.add("invalid");
          setError(errorEmailConfirm, "メールアドレスが一致しません。");
        } else {
          inEmailConfirm.classList.remove("invalid");
          clearError(errorEmailConfirm);
        }
        updateSubmitButton();
      });
      inEmailConfirm.addEventListener("focus", function () {
        if (inEmailConfirm.classList.contains("invalid")) clearError(errorEmailConfirm);
      });
      inEmailConfirm.addEventListener("input", updateSubmitButton);

      // セレクト
      inSelect.addEventListener("change", function () {
        if (isSelectValid()) {
          inSelect.classList.remove("invalid");
          clearError(errorSelect);
        }
        updateSubmitButton();
      });
      inSelect.addEventListener("blur", function () {
        if (!isSelectValid()) {
          inSelect.classList.add("invalid");
          setError(errorSelect, "選択してください。");
        }
        updateSubmitButton();
      });
    }
  }
}
